module.exports = __webpack_public_path__ + "static/media/hand_lettered_layout_sketch_for_brush_case_2020.7f072af8.webp";